// extracted by mini-css-extract-plugin
export default {"root":"base_root__oUysU"};